module.exports = __webpack_public_path__ + "static/img/logo.c1350900.png";